import * as types from './types';

const initialState = {
  ApiPara: {
    branchNumber: '',
    reportBatchId: null,
    year: ''
  },
  error: null
};

export default function ApiParaReducer(state = initialState, action) {
  switch (action.type) {
    case types.API_PARA_UPDATE_SUCCESS: {
      return {
        ...state,
        ApiPara: { ...state.ApiPara, ...action.payload }
      };
    }
    case types.API_PARA_UPDATE_FAILURE:
      return { ...state, error: action.payload };

    case types.API_PARA_CLEAR_SUCCESS: {
      return {
        ...state,
        ApiPara: initialState.ApiPara
      };
    }
    case types.API_PARA_CLEAR_FAILURE:
      return { ...state, error: action.payload };

    default:
      return state;
  }
}
